export const SlbOccEndpoints = {
    basesites: 'basesites?fields=FULL',
    cart: '/users/${userId}/carts/${cartId}?&fields=FULL',
    productsSearchByDomain: 'products/searchByDomains/${domains}?fields=DEFAULT',
    products: 'products/${productCode}?fields=FULL,code,name,summary,price(formattedValue,DEFAULT),images(galleryIndex,FULL),baseProduct,DEFAULT,averageRating,classifications,manufacturer,numberOfReviews,categories(FULL),baseOptions,variantOptions,variantType,stock(DEFAULT),description,availableForPickup,url,priceRange,multidimensional,tags',
    productReferences: 'products/${productCode}/references',
    productCaseStudies: 'products/${productCode}/case-studies?currentPage=${currentPage}&fields=DEFAULT&pageSize=4&sort=asc&sortBy=title',
    productSupportedWorkflows: 'products/${productCode}/supportedWorkflows?fields=FULL',
    productProfileComparison: '/products/${productCode}/profile-comparison?fields=FULL',
    subcriptionsWorkflow: 'subscriptions/workflows/${workflowCode}?fields=FULL',
    subcriptionsWorkflowRelated: 'subscriptions/workflows/${workflowCode}/related-products?fields=FULL&currentPage=${currentPage}&pageSize=4',
    subcriptionsWorkflowCaseStudies: 'subscriptions/workflows/${workflowCode}/case-studies?fields=FULL&currentPage=${currentPage}&pageSize=4',
    subcriptionsApplication: 'subscriptions/applications/${applicationCode}?fields=FULL',
    subcriptionsApplicationRelated: 'subscriptions/applications/${applicationCode}/related-subscriptions?fields=FULL&currentPage=${currentPage}&pageSize=4',
    subcriptionsApplicationRelatedExtensions: 'subscriptions/applications/${applicationCode}/related-extensions?fields=FULL&currentPage=${currentPage}&pageSize=4',
    subcriptionsApplicationCaseStudies: 'subscriptions/applications/${applicationCode}/related-case-studies?fields=FULL&currentPage=${currentPage}&pageSize=4',
    agora: {
        products:'products/searchAgoraProducts',
        subscriptions: '/agoraSubscriptions?fields=FULL',
        subscription: '/users/${userId}/carts/${cartId}/agora/subscription?cartPage=ORDER_REVIEW_PAGE',
        hasGateways: '/users/${userId}/carts/${cartId}/agora/gatewayRequired?cartPage=ORDER_REVIEW_PAGE'
    },
    components: 'users/${user}/cms/components?fields=FULL&sort=uid:asc&pageSize=15',
    countries: 'countries/supported?fields=DEFAULT',
    currencies: 'supportedCurrencies?fields=FULL',
    problemAreas: 'contactus/customerProblemAreas?fields=DEFAULT',
    contactUs: 'contactus',
    simulation: '/users/${userId}/carts/${cartId}/checkout/simulation?fields=DEFAULT',
    performSimulation: '/users/${userId}/carts/${cartId}/checkout/simulateCart',
    stepValidator: '/users/${userId}/carts/${cartId}/checkout/validate?fields=DEFAULT',
    stepPaymentValidator: '/users/${userId}/payment/validate',
    storage: '/users/${userId}/carts/${cartId}/checkout/storage',
    navigation: '/users/${userId}/carts/${cartId}/checkout/navigation?fields=DEFAULT',
    navigationPayment: '/onlinePaymentNavigation?fields=DEFAULT',
    addToCart: 'users/${email}/carts/${cartCode}/entries?fields=FULL',
    agoraAddToCart: 'users/${email}/carts/${cartCode}/agoraEntries?fields=FULL',
    agoraChangeQuantity: 'users/${userId}/carts/${cartCode}/agoraEntries/${entryNumber}?fields=FULL',
    shipment: '/users/${userId}/carts/${cartId}/checkout/shipment?fields=FULL',
    shipmentAddress: '/users/${userId}/carts/${cartId}/checkout/shipment/validateAddress?fields=FULL',
    payment: '/users/${userId}/carts/${cartId}/checkout/payment?fields=FULL',
    termsAndConditions: '/users/${userId}/carts/${cartId}/checkout/online-terms-conditions',
    donwloadFile: '/users/${userId}/medias/${mediaCode}',
    contactSales: '/landing-popup',
    emailUs: '/contactus/request-more-info',
    carts: {
        update: '/cart/${cartType}/update',
        updateOceanCart:  '/users/${userId}/carts/${cartId}/entries/${entryNumber}?fields=FULL',
        updateOceanLicense: '/users/${userId}/carts/${cartId}/orderLicense?fields=FULL',
        addOceanProducts: '/users/${userId}/carts/${cartId}/newCartLicense?fields=FULL'
    },
    orders: {
        getOrderById: '/orders/${orderId}?fields=FULL&sort=asc',
        place: '/users/${userId}/carts/${cartId}/checkout/review/placeOrder',
        confirmation: '/checkout/orderConfirmation',
        getOrdersByUser: '/users/${userId}/orders?pageSize=${size}&currentPage=${page}',
        getOrdersByISVUser: '/users/${userId}/orders?fields=FULL&searchBySiebelId=true&pageSize=${size}&currentPage=${page}',
        uploadDeploymentStatus: '/users/${userId}/orders/${orderCode}/refreshDeploymentStatus?ordeCode=${orderCode}',
        savePayment: '/users/${userId}/orders/${orderCode}/payment/select',
        updateEmarsysPurchase: '/users/${userId}/emarsys/${orderCode}/purchase'
    },
    coupons: {
        add: '/users/${userId}/carts/${cartId}/vouchers?voucherId=${coupon}',
        remove: '/users/${userId}/carts/${cartId}/vouchers/${coupon}',
    },
    miscs: {
        titles: '/titles?fields=DEFAULT'
    },
    store: {
        regions: '/countries/${countryIso}/regions?fields=FULL'
    },
    payments:{
        details: "/users/${userId}/carts/${cartId}/paymentdetails?fields=FULL",
        session: "/paymentmodes/sessiontransfer?method=WALLET",
    },
    orbitalPayment: {
        info: '/users/${userId}/carts/${cartId}/orbitalPayment?fields=FULL',
        order: '/users/${userId}/carts/${cartId}/checkout/payment/orbital?checkoutId=${checkoutId}',
        updatePayment: '/users/${userId}/orders/${orderCode}/payment/select/dhpp?checkoutId=${checkoutId}'
    },
    license: '/users/${userId}/carts/${cartId}/checkout/license-hardware',
    orderDetails: {
        countries: '/countries/upliftSupportedCountries',
        save: '/users/${userId}/carts/${cartId}/checkout/isv/orderDetails',
        paymentDetails: '/users/${userId}/paymentdetails?saved=true?fields=DEFAULT',
        session: '/users/${userId}/orders/${orderCode}/payment/chaseConfiguration?lang=en&curr=USD'
    },
    onlinePayments: {
        info: '/users/${userId}/onlinePayment?fields=FULL',
        details: '/users/${userId}/onlinePayment/invoice?fields=FULL&invoiceNumber=${paymentNumber}&invoiceReference=${reference}',
        currencies: '/users/${userId}/onlinePayment/supportedCurrencies?fields=FULL',
        current: '/users/${userId}/onlinePayment/currentInvoice?fields=FULL',
        submitInvoice: '/users/${userId}/onlinePayment/submitInvoice',
        payment: '/users/${userId}/onlinePayment/${invoiceNumber}/payment?fields=FULL',
        payInvoice: '/users/${userId}/onlinePayment/payCurrentInvoice',
        confirmation: 'my-account/online-payments/success/'
    },
    maintenance: {
        getQuotes: '/users/${userId}/maintenance-renewal?fields=FULL',
        getPdfQuote: '/users/${userId}/maintenance-renewal/downloadPDF/${code}?version=${version}',
        uploadFiles: '/users/${userId}/maintenance-renewal/upload-files?fields=FULL',
        reject: 'users/${userId}/maintenance-renewal/reject'
    },
    userUpdate: '/users/${userId}/complete-info',
    enterCheckout: '/users/${userId}/carts/current/checkout/enterStep',
    userPreferences: '/users/${userId}/preferences',
    userPreferencesSkip: '/users/${userId}/preferences/skip',
    variantProduct: {
        plugins: 'products/${productCode}/plugins?fields=FULL&search=${searchText}&currentPage=${currentPage}&pageSize=4',
        workflows: 'products/${productCode}/workflows?fields=FULL&search=${searchText}&currentPage=${currentPage}&pageSize=4',
        applications: 'products/${productCode}/applications?fields=FULL&search=${searchText}&currentPage=${currentPage}&pageSize=4',
    },
    customerInsigths:{
        plugins: '/customer-insights/plugins?fields=FULL',
        modules: '/customer-insights/modules?fields=FULL',
        caseStudies: '/customer-insights/case-studies?fields=FULL',
    }
}

export const SlbOccCloudSolutionsEndPoints = {
    productDetail: 'products/searchDelfiDomain/${productName}?fields=FULL'
}

export const SlbOccEdgeSolutionsEndPoints = {
    productDetail: 'products/${productName}?fields=FULL,productReferences(target(code%2Cname%2Cprice(FULL)%2CproductReferences(FULL)))',
};

export const SlbOccServicesEndPoints = {
    plpProducts: 'categories/${categoryCode}/products?fields=FULL&query=${query}&pageSize=${size}&currentPage=${page}',
    plpISVProducts: 'products/searchISVProducts?fields=FULL&query=${query}&pageSize=${size}&currentPage=${page}&lang=${lang}&curr=${currency}'
}
